import { useNavigate } from 'react-router-dom';
import { Button } from '@heroui/react';

/**
 * 无权限页：角色/权限校验不通过时跳转
 */
export default function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-6 p-6">
      <p className="text-center text-lg text-muted-foreground">您无权限访问本页面</p>
      <div className="flex gap-3">
        <Button variant="outline" onPress={() => navigate(-1)}>
          返回上一页
        </Button>
        <Button variant="primary" onPress={() => navigate('/')}>
          返回首页
        </Button>
      </div>
    </div>
  );
}
